(function () {
  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  }

  function updateShippingProgress(totalCents) {
    var shipping = document.querySelector('[data-vny-cart-shipping]');
    if (!shipping) return;

    var threshold = parseInt(shipping.getAttribute('data-shipping-threshold'), 10) || 0;
    var message = shipping.querySelector('[data-vny-shipping-message]');
    var fill = shipping.querySelector('[data-vny-shipping-fill]');
    if (!message || !fill || threshold <= 0) return;

    var remaining = threshold - totalCents;
    var percent = Math.min(100, Math.max(0, (totalCents / threshold) * 100));
    fill.style.width = percent + '%';

    if (remaining <= 0) {
      message.textContent = '✓ Congratulations! You’ve unlocked Free Shipping.';
      message.setAttribute('data-complete', '');
    } else {
      message.textContent = formatMoney(remaining) + ' away from FREE SHIPPING';
      message.removeAttribute('data-complete');
    }
  }

  function refreshCrossSell(productId) {
    var element = document.querySelector('[data-vny-cart-cross-sell]');
    if (!element) return;

    if (!productId) {
      element.innerHTML = '';
      return;
    }

    element.dataset.productId = productId;

    if (typeof element.initializeRecommendations === 'function') {
      element.initializeRecommendations(productId);
    }
  }

  function initOneClickAdd() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('.vny-cart-cross-sell-item__add');
      if (!button) return;

      var variantId = button.getAttribute('data-variant-id');
      var originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function () {
          button.textContent = 'Added';

          return fetch('/cart.js').then(function (response) {
            return response.json();
          });
        })
        .then(function (cart) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'vny-cart-cross-sell',
              cartData: cart,
            });
          }
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = originalText;
        });
    });
  }

  // Attaching (not moving) our supplemental content. Dawn's own cart lifecycle
  // (CartDrawer.renderContents on add, CartItems.updateQuantity on qty/remove)
  // wholesale-replaces the innerHTML of `#CartDrawer` / `.drawer__inner` on
  // every cart mutation, which would destroy anything permanently relocated
  // into that subtree. So the source markup lives in an inert <template> that
  // Dawn's innerHTML replacements can never reach, and this function clones a
  // fresh copy into the (possibly just-replaced) drawer every time it's called
  // — once on load, and again after every cart mutation.
  function attachExtras() {
    var template = document.querySelector('template[data-vny-cart-extras]');
    var drawer = document.querySelector('cart-drawer');
    if (!template || !drawer) return null;

    // Defensive: if a previous copy is still present (e.g. a mutation that
    // didn't wipe the DOM, such as our own cross-sell one-click add), remove
    // it first so we don't end up with duplicates.
    document.querySelectorAll('[data-vny-cart-injected]').forEach(function (el) {
      el.remove();
    });

    var header = drawer.querySelector('.drawer__header');
    var footer = drawer.querySelector('.drawer__footer .cart-drawer__footer');
    var emptyContainer = drawer.querySelector('.drawer__inner-empty');

    var clone = template.content.cloneNode(true);
    var shipping = clone.querySelector('[data-vny-cart-shipping]');
    var trust = clone.querySelector('.vny-cart-trust');
    var crossSell = clone.querySelector('[data-vny-cart-cross-sell]');
    var emptyState = clone.querySelector('[data-vny-cart-empty]');

    [shipping, trust, crossSell, emptyState].forEach(function (el) {
      if (el) el.setAttribute('data-vny-cart-injected', '');
    });

    if (header && shipping) header.insertAdjacentElement('afterend', shipping);
    if (footer) {
      if (trust) footer.insertAdjacentElement('beforebegin', trust);
      if (crossSell) footer.insertAdjacentElement('beforebegin', crossSell);
    }
    if (emptyContainer && emptyState) emptyContainer.appendChild(emptyState);

    if (template.getAttribute('data-show-savings') === 'false') {
      drawer.classList.add('vny-hide-savings');
    }

    return template.getAttribute('data-basis-product-id');
  }

  function init() {
    var basisProductId = attachExtras();

    initOneClickAdd();

    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateShippingProgress(cart.total_price);
      })
      .catch(function () {});

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        attachExtras();

        // Don't trust event.cartData's shape — it's the raw /cart/add.js
        // single-line-item response after an add (no total_price/items),
        // but the full cart object after /cart/change.js. Fetching /cart.js
        // fresh guarantees a consistent shape so the shipping bar recalculates
        // correctly after every mutation, not just quantity changes.
        fetch('/cart.js')
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            updateShippingProgress(cart.total_price);

            var newBasisId = cart.items.length ? String(cart.items[0].product_id) : '';
            if (newBasisId !== basisProductId) {
              basisProductId = newBasisId;
              refreshCrossSell(basisProductId);
            }

            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          })
          .catch(function () {});
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
